module.exports = __webpack_public_path__ + "img/Krag_Lyrikken_vender_tilbake1.3013554b.jpg";